const DlocalUpiFormView = ({
  t,
  upiId,
  pan,
  loading,
  error,
  panError,
  onUpiChange,
  onPanChange
}) => (
  <div className="upi-container">
    <div className="form-section">
      <label className="input-label">
        {t("paymentForms.upi.upiId")}
      </label>
      <div className="input-wrapper">
        <input
          type="text"
          className="upi-input"
          placeholder={t("paymentForms.upi.upiPlaceholder")}
          value={upiId}
          onChange={onUpiChange}
          disabled={loading}
        />
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>

    <div className="form-section">
      <label className="input-label">
        {t("paymentForms.upi.pan")}
      </label>
      <div className="input-wrapper">
        <input
          type="text"
          className="upi-input"
          placeholder={t("paymentForms.upi.panPlaceholder")}
          value={pan}
          onChange={onPanChange}
          disabled={loading}
          maxLength={10}
        />
      </div>
      {panError && <div className="error-message">{panError}</div>}
    </div>

    {loading && (
      <div className="loader-overlay">
        <div className="spinner-large" />
      </div>
    )}
  </div>
);

export default DlocalUpiFormView;
